import React, { ComponentType } from "react"
import useDidMount from "@/hooks/useDidMount"
import { Chip, Grid, Typography } from "@material-ui/core"
import { NodeProps } from "reactflow"

import useRDStationCRMApi from "@/hooks/useRDStationCRMApi"
import useChatBotFlowBlockDetails from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowBlockDetails"
import useChatBotFlowConstructorStore from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useChatBotFlowConstructorStore"

import { BlockNodeData } from "@/protocols/chatBotFlow"
import BaseBlock from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BaseBlock"
import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionContainer from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionContainer"
import AfterActionConditionSection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/AfterActionConditionSection"
import PluginStatusReport from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/PluginStatusReport"

import {
	getCurrentOptionByCreateRDStationContact
} from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockContent"
import ColorUtil from "@/utils/ColorUtil"

import ContactAlreadyExistsSectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/CreateRDStationContactBlock/ContactAlreadyExistsSectionEditor"

import { colors } from "@/styles/colors"

const CreateRDStationContactBlock: ComponentType<NodeProps<BlockNodeData>> = (node) => {
	const chatBotFlowConstructorStore = useChatBotFlowConstructorStore()
	const isPreview = chatBotFlowConstructorStore.isPreview
	const chatBotFlowBlockDetails = useChatBotFlowBlockDetails({ chatBotFlowBlockId: node.data.chatBotFlowBlockId })

	const {
		validatePlugin,
		getValidationContent
	} = useRDStationCRMApi()

	const pluginStatusContent = getValidationContent()

	useDidMount(async () => {
		await validatePlugin()
	})

	const getOptionLabel = () => {
		const currentOptionByCreateRDStationContact = getCurrentOptionByCreateRDStationContact(chatBotFlowConstructorStore.constructionResources, chatBotFlowBlockDetails.content)

		if (currentOptionByCreateRDStationContact) {
			return (
				<Chip
					label={`${currentOptionByCreateRDStationContact?.name}`}
					size="small"
					style={{
						...ColorUtil.getBackgroundAndContrastColor(colors.blue[300]),
						borderRadius: "8px",
						fontWeight: "bold"
					}}
				/>
			)
		} else {
			return ""
		}
	}

	return (
		<BaseBlock
			node={node}
		>
			<BlockBodySection
				fullWidth
			>
				{ !isPreview && (
					<PluginStatusReport
						pluginStatusContent={pluginStatusContent}
						onUpdate={async () => {
							await validatePlugin()
						}}
					/>
				)}

				<ContactAlreadyExistsSectionEditor
					onSave={content => chatBotFlowBlockDetails.changeContent(content)}
					chatBotFlowBlockContent={chatBotFlowBlockDetails.content}
				>
					<BlockBodySectionContainer
						text={getOptionLabel() || ""}
						placeholder="Selecione uma ação"
						title="O que fazer caso o contato já exista?"
						chatBotFlowBlockId={node?.data?.chatBotFlowBlockId}
					/>
				</ContactAlreadyExistsSectionEditor>
			</BlockBodySection>

			<BlockBodySection
				fullWidth
			>
				<Grid container>
					<Typography
						variant="caption"
					>
						<span style={{ fontWeight: 600 }}>Obs:</span> o contato é identificado pelo telefone. Se já existir, os
						dados serão atualizados; caso contrário, um novo contato será criado no RD Station CRM.
					</Typography>
				</Grid>
			</BlockBodySection>

			<AfterActionConditionSection
				nextChatBotFlowBlockRules={chatBotFlowBlockDetails.nextChatBotFlowBlockRules}
			/>
		</BaseBlock>
	)
}

export default CreateRDStationContactBlock
